import { AlertTriangle } from 'lucide-react-native'
import { StyleSheet, View } from 'react-native'
import { Text, useTheme } from 'react-native-paper'
import { useActiveLocations } from '@/hooks/useActiveLocations'

const IOS_GEOFENCE_LIMIT = 20

export function GeofenceLimitWarning({ orgId }: { orgId: string | null | undefined }) {
    const theme = useTheme()
    const { locations, isPending } = useActiveLocations(orgId)

    if (isPending || locations.length < IOS_GEOFENCE_LIMIT) return null

    return (
        <View style={[styles.container, { backgroundColor: theme.colors.tertiaryContainer }]}>
            <View style={styles.header}>
                <AlertTriangle size={20} color={theme.colors.onTertiaryContainer} />
                <Text
                    variant="titleSmall"
                    style={[styles.title, { color: theme.colors.onTertiaryContainer }]}
                >
                    Geofence Limit Warning
                </Text>
            </View>
            <Text variant="bodyMedium" style={{ color: theme.colors.onTertiaryContainer }}>
                There are currently {locations.length} active locations. When more than{' '}
                {IOS_GEOFENCE_LIMIT} are active, automatic clock-in/out accuracy may degrade for
                crews that switch jobs frequently.
            </Text>
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        padding: 16,
        borderRadius: 8,
        gap: 8,
    },
    header: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 8,
    },
    title: {
        fontWeight: '600',
    },
})
